module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/199-sudan-8c90cc378088d372e712453f982199a7.svg";